export default __webpack_public_path__ + "static/media/0x1646c835d70f76d9030df6baaeec8f65c250353d.ea13920a.webp";